module.exports = __webpack_public_path__ + "static/img/hidden_fr.e959fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/assets/hidden_fr.png
// module id = qHSz
// module chunks = 0